import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import configService from '../services/configService';

export const useCountryAvailability = () => {
  const { user } = useAuth();
  const [showCountryModal, setShowCountryModal] = useState(false);
  const [countryCode, setCountryCode] = useState(null);

  useEffect(() => {
    const checkCountryAvailability = async () => {
      if (!user?.attributes) return;

      const userCountryCode = user.attributes['custom:country_code'];
      
      // If user has a country code and it's not US/Canada (+1)
      if (userCountryCode && userCountryCode !== '+1') {
        setCountryCode(userCountryCode);
        
        try {
          // Track this login attempt for international user
          await configService.joinInternationalWaitlist(
            user.attributes.email,
            userCountryCode,
            getCountryName(userCountryCode)
          );
          
          // Show modal to inform user about availability
          setShowCountryModal(true);
        } catch (error) {
          console.error('Failed to track international user:', error);
          // Still show modal even if tracking fails
          setShowCountryModal(true);
        }
      }
    };

    checkCountryAvailability();
  }, [user]);

  const getCountryName = (code) => {
    const countries = {
      '+44': 'United Kingdom',
      '+33': 'France', 
      '+49': 'Germany',
      '+39': 'Italy',
      '+34': 'Spain',
      '+61': 'Australia',
      '+81': 'Japan'
    };
    return countries[code] || 'your country';
  };

  const closeModal = () => {
    setShowCountryModal(false);
  };

  return {
    showCountryModal,
    countryCode,
    userEmail: user?.attributes?.email,
    closeModal
  };
};